"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = __importDefault(require("./styles"));
const CircleSVG_1 = __importDefault(require("./CircleSVG"));
const SVG_1 = require("../Animations/Airplane/SVG");
const EarthLoadingIndicator = ({ style, className, }) => {
    const classes = styles_1.default();
    return (react_1.default.createElement("div", { className: `${classes.container} ${className}`, style: style },
        react_1.default.createElement("div", { className: classes.earth }),
        react_1.default.createElement(SVG_1.AirplaneLargeSVG, { className: classes.airplane }),
        react_1.default.createElement(CircleSVG_1.default, { className: classes.circle })));
};
exports.default = EarthLoadingIndicator;
